import React, { useState } from 'react';
import { motion } from 'framer-motion';
const inputClass = 'w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors';
const labelClass = 'block text-sm text-brand-white/70 mb-1';
export function CompraVentaForm() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    auto: '',
    entregaAuto: 'No',
    capital: 'Menos de U$S 3.000',
    cuota: 'Hasta $150.000',
    veraz: 'No sé',
    ingresos: 'Ninguno'
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = `Hola Flash & Go! Me interesa comprar un auto. Mis datos:
*Nombre:* ${formData.nombre}
*Teléfono:* ${formData.telefono}
*Auto de interés:* ${formData.auto}
*Entrega auto:* ${formData.entregaAuto}
*Capital:* ${formData.capital}
*Cuota máxima:* ${formData.cuota}
*Veraz:* ${formData.veraz}
*Ingresos:* ${formData.ingresos}`;
    window.open(`https://wa.me/5491127063704?text=${encodeURIComponent(message)}`, '_blank');
  };
  return <motion.div id="compra-venta" initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="max-w-3xl mx-auto mt-20 scroll-mt-28" data-id="element-121" data-mp="1zuujvtktqxae">
      <div className="text-center mb-8" data-id="element-122" data-mp="28watw07q8xe3">
        <h3 className="font-heading text-4xl md:text-5xl text-brand-white mb-3" data-id="element-123" data-mp="28v99340wswj6">
          ¿No encontrás lo que buscás?
        </h3>
        <p className="text-brand-white/70" data-id="element-124" data-mp="1h4ml1no5qt00">
          Dejanos tus datos y te conseguimos el auto ideal.
        </p>
      </div>

      <div className="bg-[#111] border border-brand-gold/30 p-6 sm:p-8 rounded-xl relative overflow-hidden" data-id="element-125" data-mp="1l5yek4a5jydh">
        <div className="absolute top-0 left-0 w-full h-1 bg-brand-gold" data-id="element-126" data-mp="1pxykqegtfnii"></div>

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-127" data-mp="tfk6wpsqfia9">
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-128" data-mp="tcxy6mu3uwqg">
            <div data-id="element-129" data-mp="xfkjs606nlf7">
              <label className={labelClass} data-id="element-130" data-mp="xf2r1jcqbpc1">Nombre completo</label>
              <input required type="text" className={inputClass} onChange={e => setFormData({
              ...formData,
              nombre: e.target.value
            })} data-id="element-131" data-mp="20r04k3ho5y0t" />
            </div>
            <div data-id="element-132" data-mp="2aj5rgyt2dp95">
              <label className={labelClass} data-id="element-133" data-mp="25ii4qpbvbukq">Teléfono</label>
              <input required type="tel" className={inputClass} onChange={e => setFormData({
              ...formData,
              telefono: e.target.value
            })} data-id="element-134" data-mp="25j1iruyedyth" />
            </div>
          </div>

          <div data-id="element-135" data-mp="1quwzaoritj9n">
            <label className={labelClass} data-id="element-136" data-mp="1qr94zne94stv">Auto de interés (marca y modelo)</label>
            <input required type="text" className={inputClass} onChange={e => setFormData({
            ...formData,
            auto: e.target.value
          })} data-id="element-137" data-mp="1mq7657o8yisf" />
          </div>

          <div data-id="element-138" data-mp="35qpuba4xslcg">
            <label className="block text-sm text-brand-white/70 mb-2" data-id="element-139" data-mp="35q6ogrsk9nes">
              ¿Tenés auto para entregar como parte de pago?
            </label>
            <div className="flex gap-4" data-id="element-140" data-mp="3angcc30axr0i">
              {['Sí', 'No'].map(opt => <label key={opt} className="flex items-center gap-2 text-brand-white cursor-pointer" data-id="element-141" data-mp="2vu3cyvbtkcf6">
                  <input type="radio" name="entrega" value={opt} className="accent-brand-gold" onChange={e => setFormData({
                ...formData,
                entregaAuto: e.target.value
              })} defaultChecked={opt === 'No'} data-id="element-142" data-mp="3ogo35sgk6ih5" />
                  <span translate="no" className="notranslate" data-id="element-143" data-mp="banytfzjhqiw">
                    {opt}
                  </span>
                </label>)}
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-4" data-id="element-144" data-mp="2oi72w1s0m0jc">
            <div data-id="element-145" data-mp="2oiyrutr3x00n">
              <label className={labelClass} data-id="element-146" data-mp="2oji4pw1wgy7t">Capital disponible en USD</label>
              <select className={inputClass} onChange={e => setFormData({
              ...formData,
              capital: e.target.value
            })} data-id="element-147" data-mp="2jib1896sil6y">
                <option data-id="element-148" data-mp="29m7v6s8ti2eq">Menos de U$S 3.000</option>
                <option data-id="element-149" data-mp="378f2wb0f4avb">U$S 3.000 a U$S 6.000</option>
                <option data-id="element-150" data-mp="3785daojac5q5">U$S 6.000 a U$S 10.000</option>
                <option data-id="element-151" data-mp="329254v80djdy">Más de U$S 10.000</option>
                <option data-id="element-152" data-mp="32adj1nv647is">Sin anticipo, 100% financiado</option>
              </select>
            </div>
            <div data-id="element-153" data-mp="2xh2c7mqcvqqv">
              <label className={labelClass} data-id="element-154" data-mp="2xgit42oyywb9">Cuota máxima mensual</label>
              <select className={inputClass} onChange={e => setFormData({
              ...formData,
              cuota: e.target.value
            })} data-id="element-155" data-mp="2sj92ijpugelu">
                <option data-id="element-156" data-mp="3l6witmk30j2o">Hasta $150.000</option>
                <option data-id="element-157" data-mp="3thdgk8cbctov">Hasta $300.000</option>
                <option data-id="element-158" data-mp="3tiokq99o83gi">Hasta $500.000</option>
                <option data-id="element-159" data-mp="1d1fjp7x8szg">Más de $500.000</option>
              </select>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-4" data-id="element-160" data-mp="6cnsrynr2989">
            <div data-id="element-161" data-mp="6b2xu7xiwo9v">
              <label className="block text-sm text-brand-white/70 mb-2" data-id="element-162" data-mp="6equhfy9lqst">
                ¿Estás en Veraz?
              </label>
              <div className="flex flex-wrap gap-4" data-id="element-163" data-mp="gb3m88a91ukx">
                {['Sí', 'No', 'No sé'].map(opt => <label key={opt} className="flex items-center gap-2 text-brand-white cursor-pointer" data-id="element-164" data-mp="kbdrfiq7wgyq">
                    <input type="radio" name="veraz" value={opt} className="accent-brand-gold" onChange={e => setFormData({
                  ...formData,
                  veraz: e.target.value
                })} defaultChecked={opt === 'No sé'} data-id="element-165" data-mp="p5896gm9ilv6" />
                    <span translate="no" className="notranslate" data-id="element-166" data-mp="e9o41ytilklf">
                      {opt}
                    </span>
                  </label>)}
              </div>
            </div>
            <div data-id="element-167" data-mp="o3n1wlmk2i7k">
              <label className="block text-sm text-brand-white/70 mb-2" data-id="element-168" data-mp="jbdg9hsh44b3">
                Ingresos
              </label>
              <div className="flex flex-wrap gap-4" data-id="element-169" data-mp="x1pabm8mcd4v">
                {['Recibo de sueldo', 'Monotributo', 'Ninguno'].map(opt => <label key={opt} className="flex items-center gap-2 text-brand-white cursor-pointer" data-id="element-170" data-mp="s35qpshhzdfo">
                    <input type="radio" name="ingresos" value={opt} className="accent-brand-gold" onChange={e => setFormData({
                  ...formData,
                  ingresos: e.target.value
                })} defaultChecked={opt === 'Ninguno'} data-id="element-171" data-mp="122mto25d7d7y" />
                    {opt}
                  </label>)}
              </div>
            </div>
          </div>

          <button type="submit" className="w-full mt-6 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-172" data-mp="19kkxbq0v7u39">
            ENVIAR CONSULTA
          </button>
        </form>
      </div>
    </motion.div>;
}